import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from 'antd';

import AlmasightsContext from 'Src/common/context/almasights';
import history from 'Src/common/utilities/history';
import DetailBar from 'Src/mentorship/components/home/detailBar';
import Description from 'Src/mentorship/components/home/description';
import MentorshipDetailCard from 'Src/mentorship/components/home/mentorshipDetailCard';
import I18nCustomFormatter from 'Src/common/components/i18nCustomFormatter';
import { getOnboardingStatus } from '../../actions';
import { TOUCHPOINTS } from '../../constants';

function Home() {
  const [loading, setLoading] = useState(false);
  const { almasightsInstance } = useContext(AlmasightsContext);
  const { programDetails } = window;

  useEffect(() => {
    setLoading(true);
    getOnboardingStatus()
      .then((res) => {
        if (res.data.is_completed) {
          history.push('/mentorship/connections');
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  }, []);

  const handleJoinMentorshipClick = () => {
    if (window.isUserAuthenticated) {
      if (almasightsInstance) {
        almasightsInstance.trackEvent({
          touchpointType: TOUCHPOINTS.JOIN_MENTORSHIP_BUTTON_CLICK,
          triggerType: 'click',
          authToken: window.csrfToken,
          object: null,
        });
      }

      history.push('/mentorship/onboarding');
    } else {
      window.open('/login?next=/mentorship', '_self');
    }
  };

  const handleGotoProgram = () => {
    window.open('/mentorship/mentors', '_self');
  };

  return (
    <Choose>
      <When condition={programDetails.name}>
        <div className="mentorship-home-page-wrapper pb24">
          <DetailBar
            programDetails={programDetails}
            handleJoinMentorshipClick={handleJoinMentorshipClick}
            handleGotoProgram={handleGotoProgram}
            loading={loading} />
          <Description programDetails={programDetails} />
          <MentorshipDetailCard title="Services offered by mentors" data={programDetails.services} />
          <Row type="flex" gutter={16}>
            <Col span={12} lg={12} xl={12} xs={24} className="guidelines-col">
              <MentorshipDetailCard
                title="Guidelines for mentees"
                data={programDetails?.mentee_guidelines}
                type="froala" />
            </Col>
            <Col span={12} lg={12} xl={12} xs={24} className="guidelines-col">
              <MentorshipDetailCard
                title="Guidelines for mentors"
                data={programDetails?.mentor_guidelines}
                type="froala" />
            </Col>
          </Row>
        </div>
      </When>
      <Otherwise>
        <div className="mentorship-home-page-wrapper pb24">
          <h1>
            <I18nCustomFormatter id="no-program-found" />
          </h1>
        </div>
      </Otherwise>
    </Choose>
  );
}

export default Home;
